import { render, staticRenderFns } from "./LogoutPopoverItem.vue?vue&type=template&id=512eeeea&"
import script from "./LogoutPopoverItem.vue?vue&type=script&lang=js&"
export * from "./LogoutPopoverItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports